import type { applicationData, clientData } from '../types/interfaces';

/**
 * Líneas de solicitud comercial vigentes. `requested_product_lines` incluye ORIGINATION
 * deshabilitadas (histórico); `products` del API son solo habilitadas. Intersectamos por `id`.
 */
export function resolveSolicitudProducts(
  data: Pick<clientData, 'products' | 'requested_product_lines'>
): applicationData[] {
  const enabledList = data.products ?? [];
  const enabledIds = new Set(enabledList.map((p) => p.id));
  const requested = data.requested_product_lines;
  if (requested != null) {
    return requested.filter((p) => enabledIds.has(p.id));
  }
  return enabledList;
}
